/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ParseEntry from 'utils/contentfulParser'
import { CurriculumRouteContentGetter } from 'layers/content/v3/Hocs/CurriculumRouteContentGetter'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import withApiError from 'layers/errorHandling/apiError'
import { resolveRouteServiceApp } from 'utils/productHelpers'
import { buildDwbProgramSupportsBrowserPath } from 'utils/urlHelpers'

import ResourcesContentV3 from './component'
import { determinePageLayout } from './pageLayouts'

const mapArticleEntry = entry => {
  if (!entry) return null

  const { derivedContent, rootContent, content } = ParseEntry(entry)
  const { anchorNavigation } = derivedContent || {}
  const { landingBanner } = rootContent || {}
  const pageLayout = determinePageLayout(anchorNavigation)
  const currentLocale = entry?.locale

  return {
    anchorNavigation,
    content,
    landingBanner,
    pageLayout,
    currentLocale,
  }
}

export const ResourcesContentV3Container = props => {
  const { routeContent, productTabTitle } = props || {}

  const { content = {}, loading, changeLocale, locale } = routeContent || {}
  const { article } = content

  const readyToLoad = !!content && !loading

  if (!readyToLoad) {
    return null
  }

  const parsedEntry = mapArticleEntry(article)

  if (!parsedEntry) {
    return null
  }

  return (
    <ResourcesContentV3
      {...parsedEntry}
      currentLocale={locale || parsedEntry.currentLocale}
      getEntryWithNewLocale={changeLocale}
      productTabTitle={productTabTitle}
    />
  )
}

ResourcesContentV3Container.propTypes = {
  productTabTitle: PropTypes.string,
  routeContent: PropTypes.object,
}

const mapStateToProps = state => ({
  productTabTitle: state.productManager?.productMap?.name || '',
})

export const resourcesContentV3CurriculumOptions = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: match => {
    const articleSlug = match?.params?.articleSlug
    if (articleSlug) {
      return buildDwbProgramSupportsBrowserPath(articleSlug)
    }

    return window?.location?.pathname || match?.url || ''
  },
}

export default withSiteContext(
  CurriculumRouteContentGetter(
    withApiError(connect(mapStateToProps)(ResourcesContentV3Container)),
    resourcesContentV3CurriculumOptions,
  ),
  { syncSiteQueryParam: false },
)
